/* eslint-disable comma-dangle, no-var */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var _ = require("underscore");

var WIDGET_PROP_BLACKLIST = require("./widget-prop-blacklist.jsx");

var EditorJsonify = {
    serialize: function serialize() {
        // Omit props that get passed to all widgets
        return _.omit(this.props, WIDGET_PROP_BLACKLIST);
    }
};

module.exports = EditorJsonify;


/*****************
 ** WEBPACK FOOTER
 ** ./src/mixins/editor-jsonify.jsx
 ** module id = 197
 ** module chunks = 0 2
 **/